import request from "../config/axiosConfig";
import {GET_LIST_AUDIENCE} from "../constants/apiEndPoint";

export const getListAudienceRequest = async (params) => {
    const result = await request({
        url: GET_LIST_AUDIENCE,
        method: "POST",
        data: params,
    });
    return result?.data?.data?.data;
}